<div id="payroll-person-editor-modal" [ngClass]="{ 'd-none': !editor || !editor.initComplete }">
  <div class="d-flex justify-content-between" *ngIf="editor && editor.initComplete">
    <h1>{{ headerName | async }}&nbsp;</h1>
    <div>
      <button
        class="btn btn-secondary"
        (click)="closePersonEditor()"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_return_to_paygrid' }">
        <i class="fas fa-lg fa-angle-left pe-1"></i>
        <span>&nbsp;Return to Payroll Grid</span>
      </button>
      <!-- save/cancel not on tabs like earnings & deductions where save logic is handled in modals-->
      <!-- task 9736. show & enable 'Cancel' button on every tab when creating a new person,
        as this abandons all changes to the person record.
      -->
      <button
        *ngIf="
          mode == 'add' ||
          (editor.activeTabIdx !== 3 && editor.activeTabIdx !== 5 && editor.activeTabIdx !== 6)
        "
        cpGTagEvent
        [params]="{ event_label: 'people_edit_cancel' }"
        class="btn btn-secondary ms-2"
        (click)="editor.onCancelClick()"
        [disabled]="!(currentTabStatus | async).IsDirty && mode == 'edit'">
        Cancel
      </button>
      <button
        *ngIf="mode === 'add'"
        type="button"
        class="btn btn-primary ms-2"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_save_person' }"
        (click)="editor.onContinueClick()">
        <span>{{ saveButtonText | async }}</span>
      </button>
      <button
        *ngIf="
          mode === 'edit' &&
          editor.activeTabIdx !== 3 &&
          editor.activeTabIdx !== 5 &&
          editor.activeTabIdx !== 6
        "
        type="button"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_save_person' }"
        class="btn btn-primary ms-2"
        (click)="onSaveClick()"
        [disabled]="!(currentTabStatus | async).IsDirty">
        <span>Save</span>
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-2">
    <small>
      <strong class="cp-green me-2">Entering Payroll for:</strong>
      <span class="me-2">
        Pay Date:&nbsp;<strong>{{ payDate | date: 'MM/dd/yyyy' }}</strong>
      </span>
      <span>
        Last Day of Pay Cycle:&nbsp;<strong>{{ periodEnd | date: 'MM/dd/yyyy' }}</strong>
      </span>
    </small>
  </div>
  <div class="pb-0">
    <person-editor
      #editor
      [clientCode]="clientCode"
      [personId]="personId"
      [mode]="mode"
      (clientOrPersonNotFound)="closePersonEditor()"
      (onEditorLeave)="closePersonEditor()"
      [editViaPayrollGrid]="true">
    </person-editor>
  </div>
</div>
<div class="payroll-person-editor modal-backdrop fade show">&nbsp;</div>
